/*
 * Accessible "Cookie settings" / "Manage cookie preferences" control.
 *
 * Two elements carry [data-cookie-settings-link]:
 *   - the footer "Cookie settings" link (<a href> — progressive enhancement), and
 *   - the "Manage cookie preferences" <button> on /pages/your-privacy-choices.
 * This script upgrades a click on either to open whichever consent manager is
 * ACTUALLY PRESENT — the presence of each manager's own control is the signal that
 * it governs consent right now:
 *   1. Consentmo's reopener (.csm-cookie-widget-link) in the DOM → forward to it.
 *   2. Else Shopify's native banner (window.privacyBanner) → showPreferences().
 *   3. Else → fall back to a URL (the <a>'s href, or the button's
 *      data-cookie-settings-fallback) so the control is never a silent dead end.
 *
 * Consentmo-FIRST (not native-first) on purpose: during the migration both objects
 * can briefly coexist (native enabled before Consentmo is disabled), and while
 * Consentmo's reopener is rendered it is still the active manager — preferring native
 * then would open the wrong panel. Consentmo removes its reopener when disabled, so
 * the control cleanly falls to native at that point.
 */
(function () {
  if (!document.querySelector('[data-cookie-settings-link]')) return;

  // Hide Consentmo's own injected control (light-DOM <li>). It stays in the DOM;
  // clicking a display:none element still fires its handler and opens the manager.
  var style = document.createElement('style');
  style.textContent = '.csm-cookie-widget-link{display:none !important;}';
  document.head.appendChild(style);

  function fallbackUrl(el) {
    return el.getAttribute('data-cookie-settings-fallback') || el.getAttribute('href');
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-cookie-settings-link]');
    if (!el) return;

    // 1. Consentmo present → it governs consent. Forward to it.
    var trigger = document.querySelector('.csm-cookie-widget-link');
    if (trigger) { e.preventDefault(); trigger.click(); return; }

    // 2. Shopify native banner → open its preferences modal. We preventDefault, then
    //    guard against BOTH a synchronous throw and a rejected promise (API present but
    //    not ready) by navigating to the fallback URL — never a silent dead end.
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') {
      e.preventDefault();
      var goUrl = fallbackUrl(el);
      try {
        var ret = pb.showPreferences();
        if (ret && typeof ret.catch === 'function') ret.catch(function () { if (goUrl) window.location.href = goUrl; });
      } catch (err) { if (goUrl) window.location.href = goUrl; }
      return;
    }

    // 3. Neither manager available. An <a href> navigates on its own; a <button> has
    //    no href, so navigate to its fallback explicitly.
    if (el.tagName === 'A' && el.getAttribute('href')) return;
    var url = fallbackUrl(el);
    if (url) { e.preventDefault(); window.location.href = url; }
  });
})();
